import { styled } from "styled-system/jsx";
import { Card } from "@ttc3k/trekker";
import { ComponentProps } from "styled-system/types";
import { PropsWithChildren } from "react";

const StyledCardSurface = styled(Card.Surface, {
  base: {
    w: "full",
    bg: "white",
    cursor: "pointer",
    transitionDuration: "normal",
    transitionProperty: "outline, border",
    transitionTimingFunction: "default",
    outline: "1px solid",
    outlineColor: "transparent",
    _hover: {
      borderColor: "border.mid",
      borderWidth: "1px",
      outline: "1px solid",
      outlineColor: "border.mid",
    },
    _focusVisible: {
      borderColor: "border.mid",
      borderWidth: "1px",
      outline: "1px solid",
      outlineColor: "border.mid",
    },
    "&[data-selected=true]": {
      borderColor: "border.dark",
      borderWidth: "1px",
      outline: "1px solid",
      outlineColor: "border.dark",
    },
  },
});

type ClickableCardSurfaceProps = ComponentProps<typeof StyledCardSurface> &
  PropsWithChildren;

/**
 * This component is to be used as the wrapper for encapsulating
 * Card components from `trekker` when needing a clickable style
 * - To support users who use tab to navigate around the screen,
 *   the surface is given a tabIndex, focus indicator, and
 *   keyboard events for ENTER and SPACE (" ")
 *   will trigger the click event
 */
export const ClickableCardSurface = ({
  children,
  ...props
}: ClickableCardSurfaceProps) => {
  return (
    <StyledCardSurface
      onKeyUp={(e: KeyboardEvent) =>
        e.key === "Enter" || e.key === " "
          ? (e.target as HTMLDivElement)?.click()
          : null
      }
      tabIndex={0}
      {...props}
    >
      {children}
    </StyledCardSurface>
  );
};
